function createFooterAccordion() {
  const accordionItems = document.querySelectorAll(
    "[data-footer-accordion-item]",
  );

  if (!accordionItems || accordionItems.length === 0) return;

  const mobileMediaQuery = window.matchMedia("(max-width: 1023px)");

  function isMobileViewport() {
    return mobileMediaQuery.matches;
  }
  function getOpenItem() {
    return (
      [...accordionItems].find((item) => {
        const toggle = item.querySelector("[data-footer-accordion-toggle]");
        return toggle && toggle.getAttribute("aria-expanded") === "true";
      }) || null
    );
  }

  /**
   * Sets the visible + ARIA state of a single accordion item.
   * @param {Element} item
   * @param {boolean} expanded
   */
  function setItemState(item, expanded) {
    if (!item) return;

    const toggle = item.querySelector("[data-footer-accordion-toggle]");
    const panel = item.querySelector("[data-footer-accordion-panel]");

    if (!toggle || !panel) return;

    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");

    if (expanded) {
      panel.removeAttribute("hidden");
    } else {
      panel.setAttribute("hidden", "");
    }
  }

  /**
   * On desktop the button should be invisible to assistive technology because
   * the panel is always open — advertising it as a collapsed/expanded toggle
   * would be misleading. We remove it from both the tab order and the AT tree.
   * On mobile it behaves as a normal interactive button.
   * @param {Element} item
   * @param {boolean} mobileMode
   */
  function setToggleInteractivity(item, mobileMode) {
    const toggle = item.querySelector("[data-footer-accordion-toggle]");

    if (!(toggle instanceof HTMLButtonElement)) return;

    if (mobileMode) {
      toggle.removeAttribute("inert");
    } else {
      // Desktop: remove from tab order and hide from screen readers entirely.
      toggle.setAttribute("inert", "");
    }
  }

  function applyDesktopState() {
    accordionItems.forEach((item) => {
      setItemState(item, true);
      setToggleInteractivity(item, false);
    });
  }

  function applyMobileState() {
    const currentlyOpen = getOpenItem();

    accordionItems.forEach((item, index) => {
      // Keep whichever item was open, or default to the first on first run.
      //const shouldBeOpen = currentlyOpen ? item === currentlyOpen : index === 0;
      const shouldBeOpen = null;
      setItemState(item, shouldBeOpen);
      setToggleInteractivity(item, true);
    });
  }

  function syncAccordionState() {
    if (isMobileViewport()) {
      applyMobileState();
    } else {
      applyDesktopState();
    }
  }

  // Attach click handlers.
  accordionItems.forEach((item) => {
    const toggle = item.querySelector("[data-footer-accordion-toggle]");

    if (!toggle) return;

    toggle.addEventListener("click", () => {
      if (!isMobileViewport()) return;

      const isCurrentlyExpanded =
        toggle.getAttribute("aria-expanded") === "true";

      const hasMultipleItems = accordionItems.length > 1;
      const shouldExpand = hasMultipleItems ? !isCurrentlyExpanded : true;

      setItemState(item, shouldExpand);
    });
  });

  syncAccordionState();

  mobileMediaQuery.addEventListener("change", syncAccordionState);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", createFooterAccordion);
} else {
  createFooterAccordion();
}
